import React from "react";
import { motion } from "framer-motion";

const StepWrapper = ({ stepNumber, title, subtitle, children }) => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.3 }}
      className="min-h-screen pt-20 lg:pt-8 pb-12 px-4 sm:px-6 lg:px-12 bg-background"
    >
      <div className="max-w-3xl mx-auto">
        {/* Step Header */}
        <motion.div
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.1 }}
          className="mb-8"
        >
          <div className="flex items-center gap-3 mb-3">
            <span className="inline-flex items-center justify-center w-8 h-8 rounded-md bg-primary text-primary-foreground text-sm font-semibold">
              {stepNumber}
            </span>
            <span className="text-sm text-muted-foreground font-medium font-body">Step {stepNumber} of 6</span>
          </div>
          <h1 className="font-display text-xl sm:text-2xl text-foreground mb-2">
            {title}
          </h1>
          {subtitle && (
            <p className="text-muted-foreground leading-relaxed font-body">
              {subtitle}
            </p>
          )}
        </motion.div>

        {/* Step Content */}
        <div>
          {children}
        </div>
      </div>
    </motion.div>
  );
};

export default StepWrapper;
